// src/features/landing/presentation/components/InnovationStepsSection.jsx
import React from "react";

export function InnovationStepsSection() {
    const steps = [
        {
            number: 1,
            title: "GA 전문 인력 후보자 발굴",
            description:
                "인바운드(SNS 및 커뮤니티), 아웃바운드(헤드헌팅 및 인적 네트워크) 등의 다양한 경로를 통해 GA 전문 인력 후보자를 발굴합니다.",
        },
        {
            number: 2,
            title: "역량에 따른 인재풀 분류",
            description:
                "GA 전문 인력의 이력·경력·성향 등을 기반으로 정량·정성 평가를 진행하고, 니즈별 인재풀로 체계적으로 분류합니다.",
        },
        {
            number: 3,
            title: "최적의 보험사/GA로 연결",
            description:
                "각 보험사/GA별 조직 구조·상품 특성·문화 등을 고려해, 회사와 GA 전문 인력 모두가 만족할 수 있는 최적의 매칭을 빠르게 진행합니다.",
        },
    ];

    return (
        <section className="innovation-steps-section">
            <div className="steps-container">
                <h2 className="steps-title">
                    <span className="title-brand">라이징브로커즈</span>는 이렇게
                    해결합니다.
                </h2>

                <div className="steps-grid">
                    {steps.map((step, index) => (
                        <React.Fragment key={step.number}>
                            <div className="step-item">
                                <div className="step-label">
                                    <div className="step-badge">
                                        STEP {step.number}.
                                    </div>
                                    <h3 className="step-title">{step.title}</h3>
                                </div>
                                <div className="step-description-box">
                                    <p className="step-description">{step.description}</p>
                                </div>
                            </div>
                            {index < steps.length - 1 && (
                                <div className="step-arrow">
                                    <div className="arrow-head">↓</div>
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>

            <style jsx>{`
                .innovation-steps-section {
                    width: 100%;
                    min-height: 100vh;
                    background: linear-gradient(to bottom, #f8f9fb 0%, #eaeef3 100%);
                    padding: 100px 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .steps-container {
                    max-width: 1200px;
                    width: 100%;
                }

                .steps-title {
                    font-size: 2.8rem;
                    font-weight: 700;
                    color: #2c3e50;
                    margin-bottom: 80px;
                    line-height: 1.4;
                }

                .title-brand {
                    color: #ff5722;
                }

                .steps-grid {
                    display: flex;
                    flex-direction: column;
                    gap: 30px;
                }

                .step-item {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }

                .step-label {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                }

                .step-badge {
                    font-size: 1.6rem;
                    font-weight: 800;
                    color: #2c3e50;
                    letter-spacing: 0.5px;
                }

                .step-title {
                    font-size: 1.8rem;
                    font-weight: 700;
                    color: #1e3556;
                    margin: 0;
                    line-height: 1.4;
                }

                .step-description-box {
                    background: linear-gradient(135deg, #dbe9f4 0%, #c5dff8 100%);
                    border-radius: 20px;
                    padding: 32px 36px;
                    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
                    border-left: 5px solid #5b8fd9;
                    max-width: 800px;
                    margin: 0 auto;
                }

                .step-description {
                    font-size: 1.15rem;
                    color: #34495e;
                    line-height: 1.9;
                    margin: 0;
                    font-weight: 500;
                }

                .step-arrow {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 15px 0;
                }

                .arrow-line {
                    width: 3px;
                    height: 30px;
                    background: linear-gradient(to bottom, #a0b5c9, #7a91a8);
                    border-radius: 2px;
                }

                .arrow-head {
                    font-size: 2rem;
                    color: #7a91a8;
                    font-weight: 700;
                    margin-top: -8px;
                }

                @media (max-width: 768px) {
                    .innovation-steps-section {
                        padding: 70px 20px;
                    }

                    .steps-title {
                        font-size: 2rem;
                        margin-bottom: 50px;
                    }

                    .step-badge {
                        font-size: 1.3rem;
                    }

                    .step-title {
                        font-size: 1.4rem;
                    }

                    .step-description-box {
                        padding: 24px 28px;
                    }

                    .step-description {
                        font-size: 1.05rem;
                    }

                    .arrow-line {
                        height: 20px;
                    }

                    .arrow-head {
                        font-size: 1.6rem;
                    }
                }
            `}</style>
        </section>
    );
}
